var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgTwitter = function SvgTwitter(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#00ABF0",
    fillRule: "evenodd",
    d: "M0 3.99C0 1.79 1.78 0 3.99 0h16.02C22.21 0 24 1.78 24 3.99v16.02c0 2.2-1.78 3.99-3.99 3.99H3.99A3.99 3.99 0 0 1 0 20.01V3.99zm19.5 3.42c-.56.25-1.14.4-1.77.5a3.07 3.07 0 0 0 1.36-1.7c-.6.35-1.26.61-1.96.74A3.07 3.07 0 0 0 14.89 6a3.05 3.05 0 0 0-3 3.72 8.79 8.79 0 0 1-6.36-3.17 3.04 3.04 0 0 0 .9 4.05c-.5-.01-1-.16-1.46-.37v.02a3.1 3.1 0 0 0 2.53 2.98 2.6 2.6 0 0 1-.74.11c-.2 0-.38-.03-.58-.06a3.09 3.09 0 0 0 2.88 2.1 6.26 6.26 0 0 1-4.56 1.26A8.87 8.87 0 0 0 9.22 18a8.63 8.63 0 0 0 8.76-8.63c0-.12 0-.25-.02-.38.6-.42 1.13-.96 1.54-1.58z"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgTwitter);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "twitter.65d26b3f85c50941314f20b866db5dad.svg";